import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

import { AntiAuthGuardService } from './shared/services/auth/anti-auth-guard/anti-auth-guard.service';
import { RedirectGuardService } from './shared/services/auth/redirect-guard/redirect-guard.service';

import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'giveaway-tool',
    data: { url: `${window.location.origin}/giveaway-tool` },
    loadChildren: () => import('./idechat/giveaway-picker/giveaway-picker.module').then(m => m.GiveawayPickerModule)
  },
  {
    path: 'login',
    canActivate: [environment.localLogin ? AntiAuthGuardService : RedirectGuardService],
    component: environment.localLogin ? LoginComponent : RedirectGuardService,
    data: {
      url: `${environment.products.connect}/login`
    },
    pathMatch: 'full'
  },
  {
    path: 'signup',
    canActivate: [RedirectGuardService],
    component: RedirectGuardService,
    data: {
      url: `${environment.products.connect}/signup`
    },
    pathMatch: 'full'
  },
  {
    path: 'forgot-password',
    canActivate: [RedirectGuardService],
    component: RedirectGuardService,
    data: {
      url: `${environment.products.connect}/forgot-password`
    },
    pathMatch: 'full'
  },
  { path: 'accounts', redirectTo: '' }, // ###L
  { path: '**', component: PageNotFoundComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      paramsInheritanceStrategy: 'always'
      /*      enableTracing: true */
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
